/** Preset coaching/player relation options (shown after family/circle members from Firestore). */
export const EXTRA_RELATION_OPTIONS = ["HS Coach", "AAU Coach", "AAU Director", "Player Contact"];

/** Omit legacy dash-only rows (e.g. "---", "--") from family-dropdown so they are not shown as options. */
export function filterFamilyDropdownPlaceholders(members) {
  if (!members?.length) return [];
  return members.filter((m) => {
    const s = String(m || "").trim();
    if (!s) return false;
    return !/^[\-—–]+$/.test(s);
  });
}

/** Select value for "Other" — stored relation is the free-text field. */
export const OTHER_RELATION_VALUE = "__OTHER__";

export function buildPresetRelationSet(familyMembers) {
  return new Set([...(familyMembers || []), ...EXTRA_RELATION_OPTIONS]);
}

/**
 * Map stored `relation` string to form state for the dropdown + optional custom text.
 */
export function splitRelationForForm(relation, familyMembers) {
  const r = String(relation || "").trim();
  if (!r) return { relationSelect: "", relationOther: "" };
  const preset = buildPresetRelationSet(familyMembers);
  if (preset.has(r)) return { relationSelect: r, relationOther: "" };
  return { relationSelect: OTHER_RELATION_VALUE, relationOther: r };
}

/**
 * Combine dropdown + optional "Other" text into the value saved on the contact.
 */
export function mergeRelationFromForm(relationSelect, relationOther) {
  if (relationSelect === OTHER_RELATION_VALUE) {
    return String(relationOther || "").trim();
  }
  return String(relationSelect || "").trim();
}
